import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "custom-container-forum max-w-[1344px] w-full" }
const _hoisted_3 = { class: "md:flex md:mt-[46px] md:gap-8" }
const _hoisted_4 = { class: "card md:h-[289px] w-full md:w-[21vw] min-w-[250px] md:min-w-[311px]" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "w-full mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BannerForum = _resolveComponent("BannerForum")!
  const _component_ExploreTopics = _resolveComponent("ExploreTopics")!
  const _component_HeaderTopics = _resolveComponent("HeaderTopics")!
  const _component_ListTable = _resolveComponent("ListTable")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_BannerForum, {
        isTeacherOrAdmin: _ctx.isTeacherOrAdmin(),
        content: _ctx.bannerContent
      }, null, 8, ["isTeacherOrAdmin", "content"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ExploreTopics, {
            onTopicSelected: _ctx.exploreTopicEmit,
            topicExplored: _ctx.topicExplored
          }, null, 8, ["onTopicSelected", "topicExplored"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_HeaderTopics, {
              searchInput: _ctx.searchInput,
              totalTopics: _ctx.totalTopics,
              onOnSearchTopics: _ctx.searchTopics,
              onOnOrderFilter: _ctx.filterByOrder,
              topicExplored: _ctx.topicExplored
            }, null, 8, ["searchInput", "totalTopics", "onOnSearchTopics", "onOnOrderFilter", "topicExplored"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ListTable, {
              topics: _ctx.topics,
              totalTopics: _ctx.totalTopics,
              query: _ctx.query,
              numberOfTopicsPerPage: _ctx.numberOfTopicsPerPage,
              onPaginate: _ctx.changePage,
              onClearFilter: _ctx.clearFilter
            }, null, 8, ["topics", "totalTopics", "query", "numberOfTopicsPerPage", "onPaginate", "onClearFilter"])
          ])
        ])
      ])
    ])
  ]))
}